import React, { useState, useEffect, useCallback  } from 'react';
import Button from '../components/Button';
import { BrowserRouter as Router, Route, Switch, Link, useNavigate, useFetcher } from 'react-router-dom';
import axios from 'axios';
import { SaveTwo, SeedProvincia, SeedMunicipio, SeedPais, SeedNac, GetWB } from '../utils/bridge';
import Spinner  from '../utils/Spinner';
import { useGoToStep } from '../hooks/useGoToStep';

import { logMessage } from '../hooks/logger';
import toast, { Toaster } from 'react-hot-toast';
import { useInputChanged } from '../context/InputChangedContext';


const Paso2 = ({ usr }) => {

    const { setInputChanged, setValidDataInputs } = useInputChanged();

    const [formData, setformData] = useState({
        ciudad:'',
        provincia:'',
        postal:'',
        municipio: '',
        pais: '',
        nac: '',
        provinciaNombre:'',
        countryNombre:'',
        correouser: usr,      
        result: ['', '']  
    });


    const [validError, setValidError] = useState('');
    const [provincia, setProvincia] = useState([]);
    const [municipio, setMunicipio] = useState([]);
    const [nac, setNac] = useState([]);    
    const [pais, setPais] = useState([]);
    const [isInitialLoad, setInitialLoad] = useState(true);


      useEffect(() => {
        if (usr) {
            setformData((prevState) => ({
                ...prevState,
                correouser: usr
            }));
        }
    }, [usr]);


    const [isUnsave, setIsUnsave] = useState(false);
    const navigate = useNavigate();


    useEffect(() => {
        setIsUnsave(
             formData.ciudad !== '' || formData.provincia !== '' || formData.postal !== ''
            || formData.municipio !== '' || formData.pais !== '' || formData.nac !== ''
        );
    }, [formData]);

    useEffect(() => {
        
        const unsave = 
         formData.ciudad !== '' || formData.provincia !== '' || formData.postal !== ''
            || formData.municipio !== '' || formData.pais !== '' || formData.nac !== ''

        setInputChanged(unsave);

        // calcula si el formulario está completo
        const valid = 
        !!formData.ciudad.trim() || !!formData.postal.trim() ||
            !!formData.provincia.trim() || !!formData.municipio.trim() ||
            !!formData.nac.trim()|| !!formData.pais.trim();

        setValidDataInputs(valid);
    }, [formData, setInputChanged, setValidDataInputs]);
    


    /*const handleChange = (e) => {
        const { name, value } = e.target;
        //console.log("cambios")
        //console.log(e)
        setformData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };*/

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "provincia") {
            const selected = provincia.find(p => p.id === value);
            setformData(prev => ({
                ...prev,
                provincia: value,
                provinciaNombre: selected ? selected.nombre : ""
            }));
        } else if (name === "municipio") {
            const selected = municipio.find(m => m.id === value);
            setformData(prev => ({
                ...prev,
                municipio: value,
                countryNombre: selected ? selected.nombre : ""
            }));
        } else {
            setformData(prev => ({
            ...prev,
            [name]: value
            }));
        }
        };



     const validateError = () => {
        const errors = {};        
        if (!formData.ciudad.trim()) errors.ciudad = 'Completar el campo ciudad es obligatorio';
        if (!formData.postal.trim() && formData.provincia.trim()) errors.postal = 'Indicar código postal';
        if (!formData.provincia.trim()) errors.provincia = 'La provincia es un campo obligatorio';
        if (!formData.municipio.trim()) errors.municipio = 'El municipio es un campo obligatorio';
        if (!formData.pais.trim()) errors.pais = 'El pais es un campo obligatorio';        
        if (!formData.nac.trim()) errors.nac = 'La nacionalidad es un campo obligatorio';  

        return errors;
    }


    /*const handleSubmit = async (e) => {
        e.preventDefault();

        const errors = validateError();
        if (Object.keys(errors).length > 0) {
            setValidError(errors);
            return;
        }

        setValidError({});

        const save = async () => {  
            setInitialLoad(true);           
            try {                
                const res = await axios.post(`${SaveTwo}`, formData); 
                console.log(formData)                
                //alert(`${res.data.datos}`);     
                //logMessage('info', 'Paso 2: Datos guardados correctamente', res.data);
                toast.success(`${res.data.datos}`);         
            } catch (error) {
                if (error.response) {                    
                    console.log(error.response.data.mensajeError)
                    const errorMessage = error.response.data.mensajeError;
                    logMessage('Error', `⚠ Error del servidor (4xx,5xx): ${errorMessage}`, error.response.status);
                    logMessage('Error', `⚠ Paso 2: Error Completo: ${errorMessage}`, error.response.data);
                    toast.error(`${errorMessage}`);
                } else {
                    toast.error(`Error: sin respuesta del servidor`);
                }
            }finally{
                setInitialLoad(false); 
            }
        }

        save();
    }*/

    const save = useCallback(async () => {
        setInitialLoad(true);
        try {
            const res = await axios.post(`${SaveTwo}`, formData);
            toast.success(`${res.data.datos}`);
        } catch (error) {
            toast.error("Error al guardar los datos");
            const errorMessage = error.response.data.mensajeError;
                    logMessage('Error', `⚠ Error del servidor (4xx,5xx): ${errorMessage}`, error.response.status);
                    logMessage('Error', `⚠ Paso 2: Error Completo: ${errorMessage}`, error.response.data);
        } finally {
            setInitialLoad(false);
        }
    }, [formData]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validateError();
        if (Object.keys(errors).length > 0) {
            setValidError(errors);
            return;
        }
        setValidError({});
        await save();
    };

    const { setSaveFn } = useInputChanged();
    useEffect(() => {
        setSaveFn(() => save);
    }, [save, setSaveFn]);

    
        const InitialLoad = async () => {
             axios.get(`${SeedProvincia}`).then(response => {
                const orderedPro = response.data.sort((a, b) => a.nombre.localeCompare(b.nombre));  
                const idx = orderedPro.findIndex(m => m.nombre === "DISTRITO NACIONAL");
                if (idx > -1) {
                    // Extrae el municipio y lo coloca al inicio
                    const distrito = orderedPro.splice(idx, 1)[0];
                    orderedPro.unshift(distrito);
                }              
                setProvincia(orderedPro);
            }).catch(error => {
                if (error.response) {
                    console.error('⚠ Error del servidor (4xx,5xx provincia):', error.response.status);
                    logMessage('Error', '⚠ Paso 2: Error del servidor (4xx,5xx provincia):', error.response.status);
                } else if (error.request) {
                    console.error('No se pudo conectar (API caída, red, CORS bloqueado)');
                    logMessage('Error', '⚠ No se pudo conectar (API caída, red, CORS bloqueado)');
                } else {
                    console.error('Error desconocido: ', error.message);
                    logMessage('Error', '⚠ Paso 2: Error desconocido:', error.message);
                }
            });
    
             axios.get(`${SeedMunicipio}`).then(response => {
                const orderedMuni = response.data.sort((a, b) => a.nombre.localeCompare(b.nombre));            
                
                const idx = orderedMuni.findIndex(m => m.nombre === "DISTRITO NACIONAL");
                if (idx > -1) {
                    // Extrae el municipio y lo coloca al inicio
                    const municipio = orderedMuni.splice(idx, 1)[0];
                    orderedMuni.unshift(municipio);
                }
                setMunicipio(orderedMuni);
            }).catch(error => { 
                console.error("Error municipio data loading: ", error) 
                logMessage('Error', '⚠ Paso 2: Error municipio data loading:', error.data);});
    
             axios.get(`${SeedPais}`).then(response => {
                //const orderedRes = response.data.sort((a, b) => a.nombre.localeCompare(b.nombre));            
                const orderedPais = response.data.sort((a, b) => a.nombre.localeCompare(b.nombre));            
                const idx = orderedPais.findIndex(m => m.nombre === "REPÚBLICA DOMINICANA");
                if (idx > -1) {
                    // Extrae el municipio y lo coloca al inicio
                    const paises = orderedPais.splice(idx, 1)[0];
                    orderedPais.unshift(paises);
                }
                
                setPais(orderedPais);
            }).catch(error => { console.error("Error pais data loading: ", error);
                logMessage('Error', '⚠ Paso 2: Error pais data loading:', error.data);
             });
    

            axios.get(`${SeedNac}`).then(response => {
                const orderedNac = response.data.sort((a, b) => a.nombre.localeCompare(b.nombre));            
                const idx = orderedNac.findIndex(m => m.nombre === "DOMINICANA");
                if (idx > -1) {
                    // Extrae el municipio y lo coloca al inicio
                    const paises = orderedNac.splice(idx, 1)[0];
                    orderedNac.unshift(paises);
                }
                setNac(orderedNac);
            }).catch(error => { 
                console.error("Error nacionalidad data loading: ", error);
                logMessage('Error', '⚠ Paso 2: Error nacionalidad data loading:', error.data);
             });
    
         
        const responseGet =  axios.get(`${GetWB}/${usr}`).then(response => {
            if (response.data) {
                console.log(response.data)
                setformData({ ...formData, ...response.data });                    
            }
        }).catch(error => {
            if (error.response) {
                console.error('⚠ Error del servidor (4xx,5xxg):', error.response.status);
            } else if (error.request) {
                console.error('No se pudo conectar (API caída, red, CORS bloqueadog)');
            } else {
                console.error('Error desconocidog: ', error.message);
                logMessage('Error', '⚠ Paso 2: Error desconocido:', error.message);
            }
        });

        setInitialLoad(false);        
        }
    
    
        useEffect(() => {
    
            if (isInitialLoad) {
                 InitialLoad();
            }
    
        }, []);
    
            
    
        const validDataInputs =            
            !!formData.ciudad.trim() ||
            !!formData.postal.trim() ||
            !!formData.provincia.trim() ||
            !!formData.municipio.trim() ||
            !!formData.nac.trim()||
            !!formData.pais.trim();
    
    
        // Hook global para navegación entre pasos
        //const goToStep = useGoToStep(validDataInputs);
        const { goToStep, ConfirmModal, IncompleteModal } = useGoToStep(save);
        const handleNext = (e) => goToStep(e, "paso3");
        const handleBack = (e) => goToStep(e, "paso1");
            
        const oldhandleNext = (e) => {
            e.preventDefault();
            if (validDataInputs) {
                const confirm = window.confirm(
                    'Cambios detectados en el formulario. ¿Seguro que desea continuar sin guardar?'
                );
                if (!confirm) {
                    e.preventDefault();
                    return;
                } else {
                    navigate("/paso3");
                }
            }
            navigate("/paso3");
        };

        const oldhandleBack = (e) => {
            e.preventDefault();
            if (validDataInputs) {
                const confirm = window.confirm(
                    'Cambios detectados en el formulario. ¿Seguro que desea continuar sin guardar?'
                );
                if (!confirm) {
                    e.preventDefault();
                    return;
                } else {
                    navigate("/paso1");
                }
            }
            navigate("/paso1");
        };
    
    if (isInitialLoad) return <Spinner />;


    return (
        <div>
            <div className="encab-contenido">
                <h1>Actualización de datos personales y laborales</h1>
            </div>

            <div className="pasos">
                <Link /*to="/paso1"*/ className="ant" onClick={(e) => goToStep(e, "paso1")}><span className="visually-hidden">Ir al paso</span> <span className="visually-hidden d-lg-block">Anterior</span></Link>
                <h2>Paso 2 de 4</h2>
                <Link /*to="/paso3"*/ className="sig" onClick={(e) => goToStep(e, "paso3")}><span className="visually-hidden">Ir al paso</span> <span className="visually-hidden d-lg-block">Siguiente</span></Link>
            </div>

            <h3>Datos de su nacimiento</h3>

            <form>

                <div className="row">
                    <div className="col-md-6">
                        <label htmlFor="text-ciudad" className="form-label"><strong>Ciudad:</strong></label>
                        <input
                            type="text"
                            id="text-ciudad"
                            name="ciudad"
                            value={formData.ciudad}
                            onChange={handleChange}
                            className="form-control"                            
                        />
                         <div id="ayuda-formato-direccion" className="form-text">
                            <p style={{ color: validError.ciudad ? 'red' : 'gray' }}>
                                {validError.ciudad ? validError.ciudad : ''}
                            </p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="select-provincia" className="form-label"><strong>Provincia:</strong></label>
                        <select id="select-provincia" 
                        /**/value={formData.provincia || '00'} 
                        /*value={formData.provincia ? `${formData.provincia}|${formData.provinciaNombre}` : '00'}*/
                        name="provincia" 
                        className="form-select" 
                        onChange={handleChange} >
                           <option value="00" disabled>Seleccionar de la lista</option>
                           {provincia.map(p => (
                                <option key={p.id} 
                                /**/value={p.id}
                                /*value={`${p.id}|${p.nombre}`}*/>
                                    {p.nombre}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 mt-3">
                        <label htmlFor="text-postal" className="form-label"><strong>Código postal:</strong></label>
                        <input
                            type="text"
                            id="text-postal"
                            name="postal"
                            value={formData.postal}
                            onChange={handleChange}
                            className="form-control"                            
                        />
                         <p style={{ color: validError.postal ? 'red' : 'gray' }}>
                            {validError.postal ? validError.postal : ''}
                        </p>
                    </div>
                    <div className="col-md-6 mt-3">
                        <label htmlFor="select-municipio" className="form-label"><strong>Municipio:</strong></label>
                        <select id="select-municipio" 
                        /**/value={formData.municipio || '00'}
                        /*value={formData.municipio ? `${formData.municipio}|${formData.countryNombre}` : '00'} */
                        name="municipio" 
                        className="form-select" onChange={handleChange} >
                            <option value="00" disabled>Seleccionar de la lista</option>
                             {municipio.map(m => (
                                <option key={m.id} value={`${m.id}`}>
                                    {m.nombre}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 mt-3">
                        <label htmlFor="select-pais-nac" className="form-label"><strong>País de nacimiento:</strong></label>
                        <select id="select-pais" value={formData.pais || '00'} name="pais" className="form-select" onChange={handleChange} >
                            <option value="00" disabled>Seleccionar de la lista</option>
                           {pais.map(p => (
                                <option key={p.id} value={p.id}>
                                    {p.nombre}
                                </option>
                            ))}
                        </select>
                         <div id="ayuda-formato-direccion" className="form-text">
                            <p style={{ color: validError.pais ? 'red' : 'gray' }}>
                                {validError.pais ? validError.pais : ''}
                            </p>
                        </div>   
                    </div>
                    <div className="col-md-6 mt-3">
                        <label htmlFor="select-nacionalidad" className="form-label"><strong>Nacionalidad:</strong></label>
                        <select id="select-nacionalidad" value={formData.nac || '00'} name="nac" className="form-select" onChange={handleChange} >
                            <option value="00" disabled>Seleccionar de la lista</option>
                              {nac.map(p => (
                                <option key={p.id} value={p.id}>
                                    {p.nombre}
                                </option>
                            ))}
                        </select>
                        <div id="ayuda-formato-direccion" className="form-text">
                            <p style={{ color: validError.nac ? 'red' : 'gray' }}>
                                {validError.nac ? validError.nac : ''}
                            </p>
                        </div>
                    </div>
                </div>

                <span className="separador"></span>

                <div className="form-botones">
                     <Button children="Guardar" onClick={handleSubmit} variant='primary'></Button>                     
                </div>

            </form>
            <Toaster position="top-center" reverseOrder={false} />
            {/* Modal */}
                <ConfirmModal />
                <IncompleteModal />
            {/* Fin Modal */}
        </div>
    )
};


export default Paso2;